import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Row } from '../../../lib/data-set/row';

import { Grid } from '../../../lib/grid';

@Component({
    selector: 'ng2-st-tbody-custom',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <a
      *ngFor="let action of grid.getSetting('actions.custom')"
      href="#"
      class="ng2-smart-action ng2-smart-action-custom-custom"
      [innerHTML]="action.title"
      (click)="onCustom(action, $event)"
    ></a>
  `,
    standalone: false
})
export class TbodyCustomComponent {
  @Input() public grid: Grid;
  @Input() public row: Row;
  @Input() public source: any;
  @Output() public custom = new EventEmitter<any>();

  public onCustom(action: any, event: any) {
    event.preventDefault();
    event.stopPropagation();

    this.custom.emit({
      action: action.name,
      data: this.row.getData(),
      source: this.source,
    });
  }
}
